import { VueComponent } from '../../../../shared/types/VueComponent'
import { User } from '../Users/types'

export enum UserSendMessageConfigType {
  Component,
  Callback
}

export type UserSendMessageComponent = {
  type: UserSendMessageConfigType.Component
  title: string
  view: VueComponent,
}

export type UserSendMessageLink = {
  type: UserSendMessageConfigType.Callback
  title: string
  callback: (userId: number, login: string) => void
}

export type UserSendMessageExtraItems = {
  (id: number, login: string, state: User['state']): Array<UserSendMessageComponent | UserSendMessageLink>
}
